module.exports = __webpack_public_path__ + "static/media/Front-Of-Head v2.6078bae3.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Front-Of-Head v2.png
// module id = 1176
// module chunks = 0